/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  advancedsection: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(4000)
    },
    '& .configbutton': {
      background: '#FFF',
      color: '#061240',
      border: '1px solid #061240',
      width: 'auto'
    }
  }
});
